import { MsgLiquidStakeSDKType as TiaMsgLiquidStake } from 'stridejs/dist/types/codegen/stride/staketia/tx'
import { MetaDataHandlerParameters } from './types'
import { TIA_CHAIN_INFO } from '@/config'
import { isSelectedCoinDenom } from '@/wallet-utils'
import { assert } from '@/utils'

const handleTiaLiquidStake = ({
  response,
  message,
  strideAddress,
  denom
}: MetaDataHandlerParameters<TiaMsgLiquidStake>): boolean => {
  // We'll exclude liquid stake tx that was committed but failed and
  // ones that did not come from the selected chain. We'll also make sure
  // to only display this transaction if DYM is the selected chain
  assert(isSelectedCoinDenom(TIA_CHAIN_INFO.stakeCurrency.coinDenom), 'TIA is not a SelectedCoinDenom')

  return response.code === 0 && message.staker === strideAddress && denom === TIA_CHAIN_INFO.stakeCurrency.coinDenom
}

export { handleTiaLiquidStake }
